// @flow

import React, { type Node } from 'react';
import { type Country } from '@tectonics/prs/country';
import { useOpenedIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { theme } from '../../../theme';
import ebanxLogoSrc from '../../../images/ebanx-logo-full.svg';

export function SafePaymentMessage(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const country = getCountry(incomingPayment);

  return (
    <div style={{ fontStyle: 'italic', color: theme.colors.gray(60) }}>
      <TextContent country={country} />
    </div>
  );
}

function TextContent(props: { country: Country }): Node {
  switch (props.country) {
    case 'br':
      return <>Pagamento seguro via <Logo /></>;
    case 'ar':
    case 'co':
    case 'cl':
    case 'mx':
    case 'uy':
    case 'py':
      return <>Pagos seguros vía <Logo /></>;
    default:
      throw new Error(`Country "${props.country}" not supported`);
  }
}

function Logo(): Node {
  return <img id="logo-ebanx" src={ebanxLogoSrc} alt="EBANX" style={{ height: '12px', width: 'auto', verticalAlign: 'text-top' }}/>;
}
